import {resetState, setBotsPlannerMode, setGameType, setHideModalsExceptGameEnd} from '../../redux/actions';
import {GAME_TYPES} from '../../constants/game';

/**
 * Подготовка стора к новой локальной партии (игра против ботов, горячее
 * кресло, режим зрителя, редактор миссий) — ДО того, как откроется экран игры.
 *
 * Первым делом стор сбрасывается, как это уже делают сюжетные миссии и
 * обучение. Без сброса в нем оставались игроки ПРЕДЫДУЩЕЙ партии — чаще всего
 * демо-матча, который крутится в главном меню и пишет в тот же стор. Поле
 * монтируется, как только игроков в сторе больше нуля (см. isPlayersReady в
 * GameContent), и GameScene.preload() успевал прочитать чужих игроков: грузил
 * скины отрядов не тех фракций, а свои пропускал. Правильные игроки приходили
 * следом — футер показывал купленный облик отрядов, а на поле стояли
 * стандартные иконки, потому что текстуры скина сцена так и не загрузила.
 *
 * После сброса игроков нет, и поле ждет, пока бутстрап локальной партии
 * поставит настоящих (с уже вычисленным hasUnitSkin, см.
 * applyFactionColorsToLocalGame).
 *
 * @param {Function} dispatch
 * @param {Object} [options]
 * @param {boolean} [options.isPlannerBotsEnabled] - планировщик ботов (только по явному включению)
 * @param {boolean} [options.isSpectatorModeEnabled] - режим зрителя: всплывающие окна скрыты со старта
 * @param {boolean} [options.isAllBotsGame] - партия из одних ботов: всплывающие окна тоже
 *   скрыты со старта (см. checkIfAllPlayersAreBots)
 */
export const prepareStoreForLocalGame = (dispatch, {
  isPlannerBotsEnabled = false,
  isSpectatorModeEnabled = false,
  isAllBotsGame = false,
} = {}) => {
  dispatch(resetState());
  dispatch(setGameType(GAME_TYPES.LOCAL));
  // Планировщик ботов (волна 29): только по явному включению админом на
  // странице настройки; LOAD_STATE локальной партии сохраняет флаг
  dispatch(setBotsPlannerMode(Boolean(isPlannerBotsEnabled)));
  // Всплывающие окна скрыты со старта у партии, в которой человек не играет:
  // закрывать окно за бота некому, а за партию их набегает на каждый бой,
  // захват города и конец раунда. Это и явный режим зрителя, и партия, где
  // игрок сам перевел все тумблеры в «Бот» (isAllBotsGame). Проверки две, а не
  // одна, потому что смысл у них разный: режим зрителя — явный выбор игрока,
  // состав «все боты» — свойство партии.
  // Партия с живым игроком (против ботов или горячее кресло) окна показывает:
  // они и есть способ узнать, что случилось не на его ходу.
  // Это только СТАРТОВОЕ значение: дальше настройку меняет сам игрок
  // чекбоксом в InGameMenu, и по ходу партии ее никто не перевыставляет
  dispatch(setHideModalsExceptGameEnd(
    Boolean(isSpectatorModeEnabled) || Boolean(isAllBotsGame)
  ));
};
